// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"c10a8606","765":"c88912cc"}[chunkId] + ".chunk.js";
};